import request from '@/utils/request'

const systemPrefix = '/django_rest/system-policy'
const companyPrefix = '/django_rest/company-policy'

export default {
  getSystemPolicyById (params) {
    return request.get(`${systemPrefix}/preview/`, { params })
  },
  getSystemPolicyByType (params) {
    return request.get(`${systemPrefix}/view/`, { params })
  },
  getSystemPolicyList () {
    return request.get(`${systemPrefix}/`)
  },
  updateSystemPolicy (params) {
    return request.post(`${systemPrefix}/`, params)
  },
  saveSystemPolicy (params) {
    return request.put(`${systemPrefix}/`, params)
  },
  deleteSystemPolicy (params) {
    return request.delete(`${systemPrefix}/${params.policy_id}/`, params)
  },
  getCompanyPolicyList () {
    return request.get(`${companyPrefix}/`)
  },
  getCompanyPolicyById (policyId) {
    return request.get(`${companyPrefix}/${policyId}/`)
  },
  createCompanyPolicy (policyInfo) {
    return request.post(`${companyPrefix}/`, policyInfo)
  },
  updateCompanyPolicy (policyId, policyInfo) {
    return request.put(`${companyPrefix}/${policyId}/`, policyInfo)
  },
  deleteCompanyPolicy (policyId) {
    return request.delete(`${companyPrefix}/${policyId}/`)
  },
  deleteCompanyPolicyFile (params) {
    return request.post(`${companyPrefix}-file/`, params)
  },
  getCompanyPolicyItemList (params) {
    return request.get('/django_rest/company-policy-item/', { params })
  },
  revokeApplication (applicationInfo) {
    return request.post('/django_rest/company/policy/revoke/application/', applicationInfo)
  },
  revokeAllApplication (candidateInfo) {
    return request.post('/django_rest/company/policy/revoke/all/', candidateInfo)
  },
  inviteCandidateAgreeConsent (params) {
    return request.post('/django_rest/company/policy/invite-candidate-agree/', params)
  },
  getCandidateAgreeConsentLink (params) {
    return request.get('/django_rest/company/policy/invite-candidate-agree/', { params })
  }
}
